<template>
  <multiselect v-model="search_text"
               label="name"
               track-by="id"
               placeholder="Fahrschüler suchen"
               open-direction="bottom"
               @select="selectCustomer"
               :options="search_result"
               :multiple="false"
               :searchable="true"
               :show-labels="false"
               :internal-search="false"
               :clear-on-select="true"
               :close-on-select="true"
               :max-height="600"
               :show-no-results="false"
               :hide-selected="true"
               @search-change="searchCustomers">
    <template v-slot:noOptions>
      Mindestens 3 zeichen eingeben
    </template>
    <template v-slot:noResult>
      Kein Schüler gefunden
    </template>
  </multiselect>
</template>

<script>
import Http from '@/shared/http-config'
import Multiselect from "vue-multiselect";

export default {
  name: "CustomerSearch",
  components: {Multiselect},
  data(){
    return {
      search_text: '',
      search_result: [],
      search_request: false,
    }
  },
  methods: {
    searchCustomers (value) {
      let self = this;
      if(value.length > 2) {
        Http.request('GET', '/customers?page=1&per_page=15&filter[search]=' + value, null, false).then(function (response) {
          self.search_result = response.data;
        });
      }
    },
    selectCustomer (customer) {
      let self = this;
      if(customer.id > 0){
        Http.request('GET', '/customers/' + customer.id + '/educations').then((educations) => {
          self.search_text = '';
          self.$router.push('/customers/dashboard/' + self.$route.params.type + '/details/' + customer.id + '/' + educations.data[0].id + '/profile')
        });
      }
    },
  }
}
</script>

<style scoped>
</style>
